var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "mt14" }, [
    _c("div", { staticClass: "v-height-flag" }, [
      _c(
        "div",
        { staticClass: "plan-tabs-content" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.tabCur,
                callback: function ($$v) {
                  _vm.tabCur = $$v
                },
                expression: "tabCur",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("access.selfassessment01"), name: "0" },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("access.mydepartment"), name: "1" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [_c("assess-statistics", { ref: "assessStatistics" })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }